import { useEffect, useState } from "react";
import ReactTooltip from "react-tooltip";

import { getAssociatedUser } from "../../../../apis";

import Title from "../../../../components/common/Title";
import CreateUser from "./CreateUser";
import Information from "../../../../assets/images/information.png";

const AddUser = ({ reference }) => {
  const [users, setUsers] = useState([]);

  const callGetUser = async () => {
    try {
      const { data } = await getAssociatedUser();
      if (data.length) setUsers(data);
      else setUsers([]);
    } catch (error) {
      console.error(error);
      window.Toast.fire({
        title: "Something went wrong",
        icon: "error",
      });
    }
  };

  useEffect(() => {
    callGetUser();
  }, []);

  return (
    <div id="add-user" ref={reference} className="mt-24">
      <Title
        className="pb-4 border-secondary-600 border-b mt-4"
        text={
          <>
            <div>Add Users</div>{" "}
            <span
              className="pl-3 cursor-pointer relative"
              data-tip
              data-for="addUsersTip"
            >
              <img className="cursor-pointer" src={Information} />
              <ReactTooltip
                id="addUsersTip"
                multiline={true}
                type="dark"
                className="z-[100] !opacity-100"
              >
                <div>
                  <h3 className="text-xl font-medium mb-1">Add Users</h3>
                  <p>
                    Assigning different user roles can decide the user's access
                    to your account{" "}
                  </p>
                  <div className="w-full mt-2 mb-2 h-[1px] bg-[#555555]"></div>
                  <h5 className="font-medium text-lg mb-1">Co-admin</h5>
                  <ul className="list-disc px-4 mb-2 text-sm">
                    <li>
                      Can create events, upload images, modify settings, delete
                      events, and view analytics.
                    </li>
                  </ul>
                  <h5 className="font-medium text-lg">Uploader</h5>
                  <ul className="list-disc px-4 mt-1 mb-2 text-sm">
                    <li>Able to upload images into an event</li>
                  </ul>
                </div>
              </ReactTooltip>
            </span>
          </>
        }
      />
      <div className="mt-7"></div>

      <div
        className={`items-start 3xl:items-center 4xl:items-center grid  grid-cols-[2.9fr_1.6fr_1fr_1fr_1fr_1fr_1fr]
         auto-cols-max gap-4 ml-2 mt-6 text-base font-semibold bg-black rounded-lg p-3`}
      >
        <div className="flex items-center gap-x-2  pl-12 cursor-pointer">
          <span>Email</span>
        </div>
        <div className="flex items-center gap-x-2 justify-start cursor-pointer">
          <span>Role</span>
        </div>
        <div className="flex items-center gap-x-2 justify-start cursor-pointer">
          <span>View Event </span>
        </div>
        <div className="flex items-center justify-start "> Create Event</div>
        <div className="flex items-baseline  justify-center cursor-pointer 3xl:whitespace-nowrap 4xl:whitespace-nowrap">
          <span className="text-center">Upload Images</span>
        </div>
        <div
          className={"flex items-center gap-x-2 justify-start  cursor-pointer "}
        >
          <span>Update Event Settings</span>
        </div>

        <div className="flex items-center gap-x-2 justify-start cursor-pointer">
          <span>Delete Event</span>
        </div>
      </div>

      <CreateUser setUsers={setUsers} />

      {users.length ? (
        users.map((el) => (
          <div className="mt-4" key={el.id}>
            <CreateUser
              setUsers={setUsers}
              callGetUser={callGetUser}
              id={el.id}
              email={el.email}
              role={el.user_role}
            />
          </div>
        ))
      ) : (
        <></>
      )}
    </div>
  );
};

export default AddUser;
